import React from 'react'
import { useSelector } from 'react-redux'

import { ModalWithFullSize } from 'components/shared'
import { Keypad } from 'components/pages'

export function KeypadModal() {
    const isModalVisible = useSelector((store) => store.global.keypadModalVisible)

    return (
        <ModalWithFullSize isModalVisible={isModalVisible}>
            <Keypad />
        </ModalWithFullSize>
    )
}
